import { apiClient, USERS } from '../../../shared/api';

export const fetchOwners = async () => {
  const response = await apiClient.get(USERS);

  return response.data;
};
